import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Tooltip
} from "@material-ui/core";
//import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import React, { useEffect, useState } from "react";
// import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { useSelector } from "react-redux";
import { AddLineItemDetails,UpdateLineItemDetails } from "../../Redux/APIs/api_Pdir";
import SnackbarCustom from "../../Components/Snackbar/Snackbar";
import Loading from "../../Components/Loader/Loader";
import { baseApiURL, apiKeys, user } from "../../Utilities/Utility";

const AddLineItemDialog = React.memo(({ open,onClose,formData,userToEdit,fromPage,inspectionNumberId }) => {
  const [isLoader, setIsLoader] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");

  const siteToken = useSelector((state) => state.saveBearerTokenReducer);
  const azureToken = useSelector((state) => state.saveTokenReducer);
  const UID = useSelector((state) => state.saveUserIdReducer);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  //const fromPage = location?.state?.from;
  const showFields = [1, 2, 6].includes(userDetails.roleId) && fromPage === '/listInspection';
  const [File, setFile] = useState(null);

  const [lineItemformData, setLineItemformData] = useState({
    bnNo: "",
    specification: "",
    min: "",
    max: "",
    sample1:"",
    sample2:"",
    sample3:"",
    sample4:"",
    sample5:"",
    sample6:"",
    sample7:"",
    sample8:"",
    sample9:"",
    sample10:"",
    result:"",
    highDemension:"",
    lowDemension:"",
    positiveTole:"",
    negativeTole:"",
    remarks:"",
    measuringInstrument:"",
      measurementID: "",
   // measurementUnit:""
    
   
  });

  // const handleChange = (e) => {
  //   setLineItemformData((prev) => ({
  //     ...prev,
  //     [e.target.name]: e.target.value,
  //   }));
    // };




    //const handleChange = (e) => {
    //    const { name, value } = e.target;

    //    let newValue = value;

    //    // Ballooning No → only integer 
    //    if (name === "bnNo") {
    //        newValue = value    //removed validation adding all 
    //        // newValue = value.replace(/[^0-9]/g, ""); // only digits

           
    //    }

       
    //    //  Set final value to state 
    //    setLineItemformData((prev) => ({
    //        ...prev,
    //        [name]: newValue,
    //    }));
    //};

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    let newValue = value;
  
    // Ballooning No → only integer 
      if (name === "bnNo") {
          newValue = value    //removed validation adding all 
      newValue = value.replace(/[^0-9]/g, ""); // only digits
  
      if (value !== newValue) {
        handleSnackOpen("Only numeric value allowed", "error");
      }
    }
  
    //  Min / Max → integer + decimal allowed
    if (name === "min" || name === "max" || name === "specification") {
      const regex = /^[0-9]*\.?[0-9]*$/;
  
      if (!regex.test(value)) {
        // block invalid input
        handleSnackOpen("Only numeric or decimal value allowed", "error");
        return;
      }
    }
  
    //  Set final value to state 
    setLineItemformData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };
  

  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpenSnack(true);
    
  };

  const handleClose = (e) => {
    setOpenSnack(false);
  };

  function handleUpload(event, row) {
    const filee = event.target.files[0];
    setFile(filee);
  }

 
  useEffect(() => {
    

    console.log("formdaraaa", formData);
    console.log('userToEdit',userToEdit)
    console.log('inspectionNumberId',inspectionNumberId);
    setLineItemformData([]);
    setOpenSnack(false);

    if(userToEdit?.editUser){
      const samples = userToEdit.editUser.inspectionSamples || [];
    setLineItemformData({
      bnNo: userToEdit?.editUser?.bnNo || null, 
      specification: userToEdit?.editUser?.specification || null, 
      min: userToEdit?.editUser?.minValue || null,
      max: userToEdit?.editUser?.maxValue || null,
      sample1: samples[0]?.sampleData || null,
      sample2: samples[1]?.sampleData || null,
      sample3: samples[2]?.sampleData || null,
      sample4: samples[3]?.sampleData || null,
      sample5: samples[4]?.sampleData || null,
      sample6: samples[5]?.sampleData || null,
      sample7: samples[6]?.sampleData || null,
      sample8: samples[7]?.sampleData || null,
      sample9: samples[8]?.sampleData || null,
      sample10: samples[9]?.sampleData || null,
      result:userToEdit?.editUser?.result || null,
      highDemension:userToEdit?.editUser?.highDimension || null,
      lowDemension:userToEdit?.editUser?.lowDimension || null,
      positiveTole:userToEdit?.editUser?.positiveTole || null,
      negativeTole:userToEdit?.editUser?.negativeTole || null,
      remarks:userToEdit?.editUser?.remarks || null,
      measuringInstrument:userToEdit?.editUser?.measuringInstrument || null,
        measurementID: userToEdit?.editUser?.measurementID || null,
      //measurementUnit: userToEdit?.editUser?.measurementUnit || null,
        
  })}
    


  }, [formData,userToEdit]);

  const handleAdd = () => {
    
    const fieldsToCheck = [
      lineItemformData.bnNo,
      lineItemformData.specification,
      lineItemformData.min,
      lineItemformData.max,
    ];
    // const isEmpty = fieldsToCheck.some(
    //   (x) => x == "" || x == null || x == undefined
    // );
    const isEmpty = fieldsToCheck.some((x) => {
      if (x === null || x === undefined) return true;
    
      // string check
      if (typeof x === "string") {
        return x.trim() === "";
      }
    
      // number check
      if (typeof x === "number") {
        return isNaN(x);
      }
    
      return false;
    });
    

    if (isEmpty) {
      handleSnackOpen("All fields are mandatory", "error");
      return; 
    }
    setIsLoader(true);
    const finalInspectionNumberId =
  inspectionNumberId ?? formData?.inspData?.inspectionNoId;

   const payloadAdd = {
      InspectionNumberId: finalInspectionNumberId,
      BnNo: lineItemformData.bnNo,
      Specification: lineItemformData.specification,
      MinValue: lineItemformData.min,
      MaxValue: lineItemformData.max,
      CreatedBy: userDetails.userId
    };

    const payloadUpdate = {
      LineItemId: userToEdit?.editUser?.lineItemId, 
      InspectionNumberId: userToEdit?.editUser?.inspectionNumberId, 
      BnNo:  lineItemformData.bnNo, 
      Specification: lineItemformData.specification,  
      MinValue: lineItemformData.min,
      MaxValue:lineItemformData.max,
      Sample1:lineItemformData.sample1,
      Sample2:lineItemformData.sample2,
      Sample3:lineItemformData.sample3, 
      Sample4:lineItemformData.sample4,
      Sample5:lineItemformData.sample5, 
      Sample6:lineItemformData.sample6,
      Sample7:lineItemformData.sample7,
      Sample8:lineItemformData.sample8,
      Sample9:lineItemformData.sample9, 
      Sample10:lineItemformData.sample10, 
      Result: lineItemformData.result, 
      LowDimension :lineItemformData.lowDemension,
      HighDimension:lineItemformData.highDemension,
      PositiveTole:lineItemformData.positiveTole, 
      NegativeTole:lineItemformData.negativeTole,  
      Remarks:lineItemformData.remarks, 
      MeasuringInstrument: lineItemformData.measuringInstrument, 
        MeasurementID: lineItemformData.measurementID || userToEdit?.editUser?.measurementID,
   //   MeasuringUnit: lineItemformData.measurementUnit || userToEdit?.editUser?.measurementUnit,
      ModifiedBy: userDetails.userId, 
    };
    

    const payload = userToEdit?.editUser ? payloadUpdate : payloadAdd;

    console.log('payload',payload);

   
    AddLineItemDetails(
      siteToken.token,
      azureToken.token,
      UID.id,
      userDetails.userEmail,
      userDetails.gid,
      userDetails.role,
      userDetails.roleId,
      payload
    )
      .then((response) => {
        console.log("8d", response);
        if (response?.response == true) {
          handleSnackOpen(response.responseMsg, "success");
          

          setIsLoader(false);
          setTimeout(onClose,3000);
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        setIsLoader(false);

        handleSnackOpen("Exception : " + error, "error");
      });
  };


  
  const handleLineItemUpload = async (selectedFile) => {
    if (!selectedFile) return;
  
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("UserId", userDetails.userId);
    formData.append("LineItemId",  userToEdit?.editUser?.lineItemId, );
    formData.append("SampleSize",  userToEdit?.editUser?.sampleSize, );
  
    try {
      const res = await fetch(`${baseApiURL}/PDIR/UploadSamples`, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + siteToken.token,
          AzureToken: azureToken.token,
        },
        body: formData,
      });
  
      const data = await res.json();
  
      if (data.result && data.result.response) {
        alert(data.result.responseMsg || "Upload Successful");
      } else {
        alert(data.result.responseMsg || "Upload Failed");
      }
    } catch (err) {
      console.error(err);
      alert("Exception: " + err);
    }
  };
  


  


   
  const handleSubmit = () => {};
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontWeight: "bold", textAlign: "left" }}>
      {userToEdit.editUser ? "Update Line Items" : "  Add Line Items"} 
        <IconButton
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
        >
          {" "}
          X{/* <CloseIcon /> */}
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <div style={{ padding: "10px" }}>
          <Box>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    disabled={userDetails.roleId == 3}
                    label="Ballooning No."   
                    className="mt-1"
                    value={lineItemformData.bnNo}
                    onChange={handleChange}
                    name="bnNo"
                    fullWidth
                    variant="outlined"
                    //placeholder="Ballooning No."
                    InputLabelProps={{
                      shrink: true,               
                    }}
                   
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    disabled={userDetails.roleId == 3}
                    label="Specification"   
                    className="mt-1"
                    value={lineItemformData.specification}
                    onChange={handleChange}
                    name="specification"
                    fullWidth
                    variant="outlined"
                   // placeholder="Specification"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                  InputLabelProps={{
                    shrink: true,               
                  }}
                    label="Min"   
                    className="mt-1"
                    value={lineItemformData.min}
                    onChange={handleChange}
                    name="min"
                    fullWidth
                    variant="outlined"
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                   label="Max"   
                    className="mt-1"
                    value={lineItemformData.max}
                    onChange={handleChange}
                    name="max"
                    fullWidth
                    variant="outlined"
                    //placeholder="Max"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                   label="Sample 1"  
                    className="mt-1"
                    value={lineItemformData.sample1}
                    onChange={handleChange}
                    name="sample1"
                    fullWidth
                    variant="outlined"
                    //placeholder="Sample 1"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                )}
                 {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label = "Sample 2"
                    className="mt-1"
                    value={lineItemformData.sample2}
                    onChange={handleChange}
                    name="sample2"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                )}
                 {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                   label = "Sample 3"
                    className="mt-1"
                    value={lineItemformData.sample3}
                    onChange={handleChange}
                    name="sample3"
                    fullWidth
                    variant="outlined"
                    //placeholder="Sample 3"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                )}
                 {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                   label = "Sample 4"
                    className="mt-1"
                    value={lineItemformData.sample4}
                    onChange={handleChange}
                    name="sample4"
                    fullWidth
                    variant="outlined"
                    //placeholder="Sample 4"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}

                  />
                </Grid>
                )}
                 {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label = "Sample 5"
                    className="mt-1"
                    value={lineItemformData.sample5}
                    onChange={handleChange}
                    name="sample5"
                    fullWidth
                    variant="outlined"
                    //placeholder="Sample 5"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                )}
                {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                   label = "Sample 6"
                    className="mt-1"
                    value={lineItemformData.sample6}
                    onChange={handleChange}
                    name="sample6"
                    fullWidth
                    variant="outlined"
                    //placeholder="Sample 6"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                )}
                 {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                   label = "Sample 7"
                    className="mt-1"
                    value={lineItemformData.sample7}
                    onChange={handleChange}
                    name="sample7"
                    fullWidth
                    variant="outlined"
                    //placeholder="Sample 7"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                )}
                 {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                   label = "Sample 8"
                    className="mt-1"
                    value={lineItemformData.sample8}
                    onChange={handleChange}
                    name="sample8"
                    fullWidth
                    variant="outlined"
                    //placeholder="Sample 8"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                )}
                {(userDetails.roleId === 3 || showFields )&& (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                   label = "Sample 9"
                    className="mt-1"
                    value={lineItemformData.sample9}
                    onChange={handleChange}
                    name="sample9"
                    fullWidth
                    variant="outlined"
                    //placeholder="Sample 9"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                )}
                {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    className="mt-1"
                    value={lineItemformData.sample10}
                    onChange={handleChange}
                    name="sample10"
                    fullWidth
                    variant="outlined"
                   // placeholder="Sample 10"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                )}
                 {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Result"   
                    className="mt-1"
                    value={lineItemformData.result}
                    onChange={handleChange}
                    name="result"
                    fullWidth
                    variant="outlined"
                    //placeholder="Result"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                )}
                 {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="High Diemension"   
                    className="mt-1"
                    value={lineItemformData.highDemension}
                    onChange={handleChange}
                    name="highDemension"
                    fullWidth
                    variant="outlined"
                    //placeholder="Result"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                )}

                {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Low Diemension"   
                    className="mt-1"
                    value={lineItemformData.lowDemension}
                    onChange={handleChange}
                    name="lowDemension"
                    fullWidth
                    variant="outlined"
                    //placeholder="Result"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                )}
                {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="PositiveTole"  
                    className="mt-1"
                    value={lineItemformData.positiveTole}
                    onChange={handleChange}
                    name="positiveTole"
                    fullWidth
                    variant="outlined"
                    //placeholder="PositiveTole"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                )}
                {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Negative Tole"  
                    className="mt-1"
                    value={lineItemformData.negativeTole}
                    onChange={handleChange}
                    name="negativeTole"
                    fullWidth
                    variant="outlined"
                    //placeholder="negativeTole"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                    disabled={userDetails.roleId == 3}
                  />
                </Grid>
                )}

              {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                   label="Remark"  
                    className="mt-1"
                    value={lineItemformData.remarks}
                    onChange={handleChange}
                    name="remarks"
                    fullWidth
                    variant="outlined"
                    //placeholder="Remark"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                  />
                </Grid>
                )}
                 {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                  label="Measuring Instrument"
                    className="mt-1"
                    value={lineItemformData.measuringInstrument}
                    onChange={handleChange}
                    name="measuringInstrument"
                    fullWidth
                    variant="outlined"
                    //placeholder="Measuring Instrument"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                  />
                </Grid>
                )}
                 {(userDetails.roleId === 3 || showFields) && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Measuring Id"
                    className="mt-1"
                    value={lineItemformData.measurementID}
                    onChange={handleChange}
                    name="measurementID"
                    fullWidth
                    variant="outlined"
                    //placeholder="Measuring Id"
                    InputLabelProps={{
                      shrink: true,               
                    }}
                  />
                </Grid>
                              )}
                              {(userDetails.roleId === 3 || showFields) && (
                                  <Grid item xs={12} sm={6} md={3}>
                                      <TextField
                                          label="Measuring Unit"
                                          className="mt-1"
                                       // value={lineItemformData.measurementUnit}
                                          onChange={handleChange}
                                          name="measuringUnit"
                                          fullWidth
                                          variant="outlined"
                                          //placeholder="Measuring Id"
                                          InputLabelProps={{
                                              shrink: true,
                                          }}
                                      />
                                  </Grid>
                              )}
 



                
              </Grid>
            </form>
          </Box>

          <Box
            item
            style={{
              gridColumn: "2/ 3",
              display: "flex",
              justifyContent: "center",
              gap: 2,
              padding: "15px",
            }}
          >
            <Button
              variant="contained"
              className="pt-button--primary"
              onClick={handleAdd}
            >
               {userToEdit.editUser ? "Update" : "Save"} 
            </Button>

            <span style={{ marginLeft: "20px" }}>
              <Button className="pt-button--primary" onClick={onClose}>
                Cancel
              </Button>
            </span>
          </Box>
        </div>
      </DialogContent>
      <SnackbarCustom
        open={openSnack}
        message={snackMessage}
        alertType={alertType}
        handleClose={handleClose}
        autoHideDuration={3000}
      />
      {isLoader ? <Loading loaderText="Loading...." /> : <></>}
    </Dialog>
  );
});

export default AddLineItemDialog;
